import React, { createContext, useState, useEffect } from 'react';
import { createTheme, Customizer } from '@fluentui/react';
import { withResponsiveMode } from 'office-ui-fabric-react/lib/utilities/decorators/withResponsiveMode';

export const AppThemeContext = createContext();

export const defaultTheme = createTheme({
    defaultFontStyle: { fontFamily: 'IRANSans, Segoe UI, Segoe WP, Tahoma, Arial, sans-serif' },
    palette: {
        themePrimary: '#0078d4',
        themeLighterAlt: '#eff6fc',
        themeLighter: '#deecf9',
        themeLight: '#c7e0f4',
        themeTertiary: '#71afe5',
        themeSecondary: '#2b88d8',
        themeDarkAlt: '#106ebe',
        themeDark: '#005a9e',
        themeDarker: '#004578',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    },
    fonts: {
        medium: {
            color: '#323130',
        }
    }
});

export const darkTheme = createTheme({
    defaultFontStyle: { fontFamily: 'IRANSans, Segoe UI, Segoe WP, Tahoma, Arial, sans-serif' },
    palette: {
        themePrimary: '#3dabff',
        themeLighterAlt: '#02070a',
        themeLighter: '#0a1b29',
        themeLight: '#12334d',
        themeTertiary: '#256799',
        themeSecondary: '#3696e0',
        themeDarkAlt: '#51b3ff',
        themeDark: '#6cbfff',
        themeDarker: '#92d0ff',
        neutralLighterAlt: '#434343',
        neutralLighter: '#4b4b4b',
        neutralLight: '#575757',
        neutralQuaternaryAlt: '#5f5f5f',
        neutralQuaternary: '#656565',
        neutralTertiaryAlt: '#7f7f7f',
        neutralTertiary: '#f7f8f8',
        neutralSecondary: '#f8f9f9',
        neutralPrimaryAlt: '#f9fafa',
        neutralPrimary: '#f1f3f4',
        neutralDark: '#fcfcfd',
        black: '#fdfefe',
        white: '#3b3b3b',
    },
    fonts: {
        medium: {
            color: "#f1f3f4",
        }
    },
});

export const AppThemeProvider = withResponsiveMode(React.forwardRef((props, ref) => {
    const [isDark, setDark] = useState(false);
    const [myTheme, setMyTheme] = useState(defaultTheme);

    const setDarkTheme = (value) => {
        if (value) {
            setDark(true);
            setMyTheme(darkTheme);
        } else {
            setDark(false);
            setMyTheme(defaultTheme);
        }
    }

    useEffect(() => {
        const uf = () => {
            // if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            //     setDarkTheme(true);
            // }
        }

        uf();

    }, []);

    return (
        <Customizer settings={{ theme: myTheme }}>
            <AppThemeContext.Provider value={{ theme: myTheme, isDark, setDarkTheme, responsiveMode: props.responsiveMode }} >
                {props.children}
            </AppThemeContext.Provider>
        </Customizer>
    );
}));